import toast from "react-hot-toast";

export const QUIZ_START_LINK = "https://t.me/FitGuid_bot?start";

type MaybeErrorWithStatus = {
  status?: number;
  originalStatus?: number;
};

export const isQuizNotCompletedError = (error: unknown): boolean => {
  if (typeof error !== "object" || error === null) {
    return false;
  }

  const possibleError = error as MaybeErrorWithStatus;
  const status = possibleError.status ?? possibleError.originalStatus;

  return status === 400;
};

export const notifyQuizNotCompleted = () => {
  toast.error(
    "Вы еще не прошли анкету. Давай сделаем это сейчас?",
    { duration: 7000 }
  );
};

